export const botMessages = [
  [
    {
      type: "bot",
      message: "Hello, are you a member?",
    },
  ],
];

export const userMessages = [
  {
    type: "user",
    inputType: "toggleButton",
    options: [
      { text: "No, I'd like to register as a member", value: "No" },
      {
        text: "I am responding to an invite",
        value: "I am responding to an invite",
      },
      { text: "Yes, I am a registered member", value: "Yes" },
    ],
    key: "is_member",
  },
];
export const registration_botMessages = [
  [
    {
      type: "bot",
      message: "May I take your first name please?",
    },
  ],
  [
    {
      type: "bot",
      message: "Perfect. I need to verify your mobile number now please?",
    },
  ],
  [
    {
      type: "bot",
      message: "Please confirm the sms code received.",
    },
  ],
];
export const registration_userMessages = [
  {
    type: "user",
    inputType: "input",
    key: "firstname",
    placeholder: "First Name Only",
    isNext: true,
  },
  {
    type: "user",
    inputType: "input",
    placeholder: "",
    key: "phone",
  },
  {
    type: "user",
    inputType: "input",
    placeholder: "6-digits",
    key: "sms",
  },
];
export const registered_botMessages = [
  [
    {
      type: "bot",
      message: "Ok. I need to verify your mobile number now please?",
    },
  ],
  // [
  //   {
  //     type: "bot",
  //     message: "Please confirm the sms code received.",
  //   },
  // ],
];
export const registered_userMessages = [
  {
    type: "user",
    inputType: "input",
    placeholder: "",
    key: "phone",
  },
  // {
  //   type: "user",
  //   inputType: "input",
  //   placeholder: "6-digits",
  //   key: "sms",
  // },
];
export const registration_lightuser_botMessages = [
  [
    {
      type: "bot",
      message: "May I take your first name please?",
    },
  ],
];
export const registration_lightuser_userMessages = [
  {
    type: "user",
    inputType: "input",
    key: "firstname_lightuser",
    placeholder: "First Name Only",
    isNext: true,
  },
];



// WEBPACK FOOTER //
// ./src/screens/Profile/constants/messages.js